import { useState } from 'react';
/**
 * Returns a flag and a function to toggle it.
 *
 * @param {Boolean} defaultValue Default value
 */

export default function useToggle(defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  var _useState = useState(defaultValue),
      value = _useState[0],
      setValue = _useState[1];

  var toggleValue = function toggleValue() {
    return setValue(function (prevValue) {
      return !prevValue;
    });
  };

  return [value, toggleValue];
}